var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view',{ref:"view",attrs:{"originData":_vm.originData,"fundCount":_vm.fundCount}})],1),_c('main-tab-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }